import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IContact } from 'src/app/models/interfaces/contact.interface';

export class ContactDetailContext extends DefaultDetailContext<IContact, number> {}
